import { createContext } from 'react'

export const PreviewSettings = createContext({ theme: 'light', density: 'comfortable' })
